import Grid from "@mui/material/Grid2";
import { InternalPage } from "../../../components/primitives/layout/InternalPage";
import { gaps } from "../../../components/primitives/spacing";
import { InvestigationsHeader } from "../InvestigationsHeader";
import { CORPUS_SCAN_HEADINGS, CORPUS_SCAN_KEYS } from "./corpus_scan_headings";
import { CORPUS_SCAN_ICONS } from "./corpus_scan_icons";
import { CorpusScanCard } from "./CorpusScanCard";
import { MissingFieldScan } from "./MissingFieldScan";
import { MissingSectionFilesScan } from "./MissingSectionFilesScan";
import { useCorpusScan } from "./useCorpusScan";

/** The scans that look across the whole corpus for what needs fixing. Pick one from the cards, fill
 *  in its fields and run it: it reads every document, so it runs only when asked, and it offers the
 *  batch job that fixes what it found. */
export default function CorpusScan() {
  const { selected, setSelected, badges, missingField, missingSectionFiles } = useCorpusScan();

  return (
    <InternalPage width="full">
      <InvestigationsHeader />
      <Grid container spacing={gaps.base}>
        {CORPUS_SCAN_KEYS.map((key) => (
          <Grid key={key} size={{ xs: 12, sm: 6, md: 4 }}>
            <CorpusScanCard
              {...CORPUS_SCAN_HEADINGS[key]}
              Icon={CORPUS_SCAN_ICONS[key]}
              selected={selected === key}
              badge={badges[key]}
              onSelect={() => setSelected(key)}
            />
          </Grid>
        ))}
      </Grid>
      {selected === "missing_field" ? <MissingFieldScan scan={missingField} /> : null}
      {selected === "missing_section_files" ? (
        <MissingSectionFilesScan scan={missingSectionFiles} />
      ) : null}
    </InternalPage>
  );
}
